import type { TemplateItem } from 'inspection-types';

import { isInherited } from '../model/origin';
import {
  getQuestionTypeDisplay,
  type QuestionTypeDisplay,
} from '../model/questionTypeCatalog';
import { LABEL_KEYS, type BadgeViewModel } from './messages';

export type QuestionRowViewModel = {
  id: string;
  label: string;
  responseType: QuestionTypeDisplay;
  isHidden: boolean;
  badges: BadgeViewModel[];
};

function createBadges(item: TemplateItem, isHidden: boolean): BadgeViewModel[] {
  const lock: BadgeViewModel[] = isInherited(item)
    ? [{ kind: 'lock', tooltipKey: LABEL_KEYS.lockQuestionTooltip }]
    : [];
  const hidden: BadgeViewModel[] = isHidden
    ? [{ kind: 'hidden', tooltipKey: LABEL_KEYS.hiddenQuestionTooltip }]
    : [];

  return [...lock, ...hidden];
}

export function createQuestionRowViewModel(
  item: TemplateItem,
  isSectionHidden: boolean
): QuestionRowViewModel {
  const isHidden = Boolean(item.removed) || isSectionHidden;

  return {
    id: item.id,
    label: item.label,
    responseType: getQuestionTypeDisplay(item.questionType),
    isHidden,
    badges: createBadges(item, isHidden),
  };
}
